import { Injectable } from '@angular/core'
import { GbBaseQuestion } from 'libs/shared/utils/forms/src/lib/gb-base-question'
import { FieldTypeEnum, StringMap } from 'libs/shared/models/shared.models'
import { Observable, combineLatest, map } from 'rxjs'
import {
  EventTicketCustomFieldEntity,
  EventTicketCustomValueEntity,
} from 'libs/shared/event-tickets/data-access/src/lib/+state/base-event-tickets.models'

@Injectable({
  providedIn: 'root',
})
export class GbEventTicketFormQuestionsService {
  /**
   * Returns an observable emitting an array of the custom fields
   * with their values formatted to the GbBaseQuestion Class
   */
  getFormattedCustomFields$(
    customFields$: Observable<EventTicketCustomFieldEntity[] | undefined>,
    customValues$: Observable<EventTicketCustomValueEntity[] | undefined>,
    index?: number,
    shouldPrepopulateForm?: boolean,
    allOptional?: boolean,
  ): Observable<GbBaseQuestion<string | boolean>[]> {
    return combineLatest([customFields$, customValues$]).pipe(
      map(([customFields, customValues]) => {
        let questions: GbBaseQuestion<string | boolean>[] = []

        customFields?.forEach((customField) => {
          let overrideValue = undefined
          let overrideValueUuid = undefined

          if (shouldPrepopulateForm) {
            const value = customValues?.find((v) => v.custom_field.uuid === customField.uuid)

            if (value) {
              overrideValue = value.value
              if (customField.field_type === FieldTypeEnum.Checkbox) {
                overrideValue = value.value === 'true'
              }
              overrideValueUuid = value.uuid
            }
          }

          questions.push(
            new GbBaseQuestion({
              key: index ? `${customField.uuid}_${index}` : customField.uuid,
              label: customField.field_name,
              controlType: customField.field_type,
              required: allOptional ? false : customField.required,
              helpText: customField.help_text,
              order: customField.order,
              value: overrideValue !== undefined ? overrideValue : customField.default_value || '',
              valueUuid: overrideValueUuid,
              choices: customField.choices,
              editable: true,
            }),
          )
        })

        return questions
      }),
    )
  }

  getFormattedCustomValues(customFields: StringMap<string>) {
    const customValues = Object.entries(customFields).map(([key, value]) => {
      const customFieldId = key.split('_')[0] // remove index from key (required when multiple forms present)
      return { custom_field: customFieldId, value: `${value}` }
    })
    return customValues
  }
}
